
import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, signal, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { QuickSearchApis } from '../../../../services/common/quickSearch';
import { ShortDetailCardComponent } from "../short-detail-card/short-detail-card.component";
import { SvgIconsComponent } from "../../../commonComponent/svg-icons/svg-icons.component";
import { CheckboxComponent } from "../../../commonComponent/formComponent/checkbox/checkbox.component";
import { Subject } from 'rxjs';

@Component({
  selector: 'app-quick-search',
  imports: [
    FormsModule,
    ShortDetailCardComponent,
    SvgIconsComponent,
    CheckboxComponent
],
  templateUrl: './quick-search.component.html',
  styleUrl: './quick-search.component.css'
})
export class QuickSearchComponent implements OnInit, OnDestroy {

  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  private destroy$ = new Subject<void>();

  payload = signal<any>({
    search_for: ['LOAD'],
    search: ''
  });
  searchData = signal<any>([]);
  combinedData = signal<any>([]);

  @Output() onClose = new EventEmitter<any>();

  constructor(
    private quickSearchApi: QuickSearchApis
  ) { }

  ngOnInit(): void {
    this.getListData(this.payload());

    setTimeout(() => {
      this.searchInput?.nativeElement.focus();
    }, 0);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onChange(event: any) {
    const searchTerm = (event.target as HTMLInputElement).value;
    this.payload.update(prev => ({
      ...prev,
      search: searchTerm
    }));
    if (this.payload()?.search?.length > 0) {
      const payloadData = this.payload();
      const { search_for, ...restPayload } = payloadData;
      const searchParam = (search_for || []).join(',');
      this.getListData({ search_for: searchParam.toString(), ...restPayload });
    }
  }

  handleChange(event: any) {
    const { name, value } = event;
    if (value) {
      this.payload.update(prev => ({
        ...prev,
        search_for: [...(prev.search_for || []), name]
      }));
    } else {
      this.payload.update(prev => ({
        ...prev,
        search_for: (prev.search_for || []).filter((item: string) => item !== name)
      }));
    }
    const payloadData = this.payload();
    const { search_for, ...restPayload } = payloadData;
    const searchParam = (search_for || []).join(',');
    this.getListData({ search_for: searchParam.toString(), ...restPayload });
  }

  getListData(params: any = {}) {
    this.quickSearchApi.getListData(params).subscribe({
      next: (res) => {
        this.searchData.set(res?.response?.detail);
        this.combinedData.set({
          list: [
            ...this.searchData()?.load || [],
            ...this.searchData()?.truck || [],
            ...this.searchData()?.trailer || [],
            ...this.searchData()?.driver || [],
            ...this.searchData()?.customer || [],
          ]
        });
      },
      error: (err) => {
        console.error('Error fetching search data:', err);
      }
    });
  }

  handleClose() {
    this.onClose.emit();
  }
}
